var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button-download-term-lamps',{attrs:{"event":_vm.event,"event-id":_vm.eventId,"lamps":_vm.lamps,"customer":_vm.customer}}),_vm._v(" "),_c('upload-term-lamps',{on:{"update-file":function($event){return _vm.$emit('upload-file', $event)}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bb8e41b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Lamps/ActionTermLamps.vue
// module id = vJ5r
// module chunks = 10